// Utilidad para obtener la URL base de la API
export const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // Si estamos en localhost, usar localhost para la API
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:4455';
  }
  
  // Para dominios externos, usar el mismo hostname (nginx proxy)
  return `${protocol}//${hostname}`;
};

// Función helper para construir URLs de la API
export const apiUrl = (endpoint: string): string => {
  const baseUrl = getApiBaseUrl();
  // Asegurar que el endpoint comience con /
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};
